import socketIOClient from "socket.io-client";

let socket = undefined;

const socketInitialisation = () => {
  let URL = window.ENV.TUTOR_API_URL;
  socket = socketIOClient(URL, {
    transports: ["websocket"],
  });
};
const disconnectSocket = () => {
  socket && socket.disconnect();
  socket = undefined;
};

export { socketInitialisation, disconnectSocket };
